import React, { useEffect, useState } from "react";
import { Button, CloseButton, Form, Offcanvas } from "react-bootstrap";
import CallResponse from "./CallResponse";
import Mood from "./Mood";
import SaveFeedback from "./SaveFeedBack";
import Regularity from "./Regularity";
import Reaction from "./Reaction";
import Reasons from "./Reasons";
import InputFeedback from "./InputFeedBack";
import Score from "./Score";
import ReasonForNotOrdering from "./ReasonForNotOrdering";
import Comments from "./Comments";
import Tick from "assets/svgs/tick";
import BlueTick from "assets/svgs/blue_tick";
import MedicalSlotBooking from "./MedicalSlotBooking";

import { buttonStyle, formRow, selected } from "./commonFunction";
import { createMeidcalEscalationTicket } from "modules/navbar/top/store";
import { isEmpty } from "lodash";
import MedDoctorBooking from "./MedDoctorBooking";
import MedDoctorBookingSlot from "./MedDoctorBookingSlot";
import SlotBookingDisposition from "./SlotBookingDisposition";
import { formDisposition } from "config";
import { Radio } from "antd";
import { UNANSWERED_OPTION } from "config";

import { DispositionComponent } from "../../lead_Detail_pop_up/DispositionComponent";
import { DISP_FLAG } from "../../utilities/utility";

function FeedbackForm({
  orderCount,
  data,
  week,
  id,
  bookingId,
  list,
  customerId,
  setData,
  setBooking,
  orders,
  customer,
}) {
  const [show, setShow] = useState(false);
  const [submitFlag, setSubmitFlag] = useState(0);
  const cxOrderDisplayId =
    orders && !isEmpty(orders) ? orders[0]?.order_display_id : null;
  const [orderDisplayId, setOrderDisplayId] = useState(cxOrderDisplayId);
  const [ticketObject, setTicketObject] = useState(null);
  const [unansweredFlag, setUnanswerFlag] = useState(false);
  const [formData, setFormData] = useState({
    callResponse: null,
    regularity: null,
    mood: null,
    reaction: null,
    reason: null,
    reactions: null,
    category: null,
    gutHealth: null,
    energy: null,
    hairGrowth: null,
    hairLoss: null,
    reasonForNotOrdering: null,
    comments: null,
    interested_in_community: null,
    is_doctor_required: null,
  });

  const renderedComponents = [
    { name: "callResponse", value: formData.callResponse },
  ];
  useEffect(() => {
    setFormData({
      callResponse: null,
      regularity: null,
      mood: null,
      reaction: null,
      reason: null,
      reactions: null,
      category: null,
      gutHealth: null,
      energy: null,
      hairGrowth: null,
      hairLoss: null,
      reasonForNotOrdering: null,
      comments: null,
      is_doctor_required: null,
    });
  }, [customerId]);

  const handleShow = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setOrderDisplayId(null);
  };

  const pushComponent = (name, value) => {
    renderedComponents.push({ name, value });
  };

  const handleUnanswer = (event) => {
    const { value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      script_unfullfill: value === "script_unfullfill",
      dont_want_talk: value === "dont_want_talk",
      did_not_pick_up: value === "did_not_pick_up",
      cx_wants_callBack: value === "cx_wants_callBack",
    }));
    setUnanswerFlag(true);
  };

  const handleCallResponseOnchange = (event) => {
    const name = event.target.name;
    const value = event.target.checked;
    console.log("value", value);
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  return (
    <>
      {list ? (
        <div className="cursor-pointer" onClick={() => handleShow("lg-down")}>
          <BlueTick />
        </div>
      ) : (
        <Button className="flex-1" onClick={() => handleShow("lg-down")}>
          <Tick />
        </Button>
      )}
      <Offcanvas
        show={show}
        placement={"end"}
        style={{ width: DISP_FLAG ?"77%":"40%" }}
        onHide={handleClose}
      >
        <Offcanvas.Header CloseButton>
          <Offcanvas.Title>Add Feedback</Offcanvas.Title>
          <CloseButton
            className="btn btn-circle btn-sm transition-base p-0"
            onClick={handleClose}
          />
        </Offcanvas.Header>
        <Offcanvas.Body>
        <div className="d-flex gap-3 flex-row">
            <div>
              {DISP_FLAG &&<DispositionComponent customer={customer} />}
            </div>
          <div>
          <div
            style={{ maxHeight: "83vh", overflowY: "scroll" }}
            className="scrollable-container"
          >
            <div>
              <CallResponse
                formData={formData}
                buttonStyle={buttonStyle}
                selected={selected}
                setFormData={setFormData}
                formRow={formRow}
              />
              {formData.callResponse === "answered" &&
              (data?.tag !== "SLOT_BOOKING" ||
                data?.tag === "IVR_BOOKING" ||
                data?.tag === "FEEDBACK_CALL") ? (
                <>
                  <Mood
                    formData={formData}
                    buttonStyle={buttonStyle}
                    selected={selected}
                    setFormData={setFormData}
                    formRow={formRow}
                  />
                  {pushComponent("mood", formData.mood)}
                </>
              ) : (
                formData.callResponse === "answered" && (
                  <>
                    {orders.length === 1 && data?.tag === "SLOT_BOOKING" && (
                      <Form.Check
                      className="mt-5"
                      inline
                      type="checkbox"
                      id="comunityCheck"
                      name="interested_in_community"
                      checked={formData?.interested_in_community}
                      onChange={handleCallResponseOnchange}
                      label={
                        <span className="fw-bold">Interested in Community</span>
                      }
                    />
                    )}
                    {data?.tag === "SLOT_BOOKING" && <SlotBookingDisposition />}
                    <div className="mt-3">
                      <Comments
                        setFormData={setFormData}
                        length={formData?.comments?.length}
                      />
                      {pushComponent("comments", formData.comments)}
                    </div>
                  </>
                )
              )}
              {formDisposition.includes(formData?.callResponse) && (
                <div>
                  {UNANSWERED_OPTION.includes(week) && formData.callResponse === 'unanswered' ? (
                    <div className="d-flex gap-2 flex-column mt-3">
                      <Radio.Group
                        className="d-flex gap-3 flex-column"
                        onChange={handleUnanswer}
                      >
                        <Radio value="script_unfullfill">
                          Partially answered because not able to cover all the
                          elements of the script!
                        </Radio>
                        <Radio value="dont_want_talk">
                          Customer pickup but does not want to talk!
                        </Radio>
                        <Radio value="did_not_pick_up">
                          Customer did not pick up!
                        </Radio>
                        <Radio value="cx_wants_callBack">
                          Customer pickup but wants a call back later !
                        </Radio>
                      </Radio.Group>
                    </div>
                  ) : null}
                  
                  { !unansweredFlag && formData.callResponse === 'unanswered' && UNANSWERED_OPTION.includes(week) ? null :<SaveFeedback
                    setData={setData}
                    setBooking={setBooking}
                    customerId={customerId}
                    setShow={setShow}
                    bookingId={bookingId}
                    week={week}
                    formData={formData}
                    selected={selected}
                    buttonStyle={buttonStyle}
                    formRow={formRow}
                    renderedComponents={renderedComponents}
                    id={id}
                  />}
                </div>
              )}
              {/* {formData?.callResponse === "answered" && (
                <>
                  <MedDoctorBooking
                    formData={formData}
                    buttonStyle={buttonStyle}
                    selected={selected}
                    formRow={formRow}
                    setFormData={setFormData}
                  />
                </>
              )} */}
              {formData?.is_doctor_required == "yes" &&
                formData?.callResponse === "answered" && (
                  <div>
                    <MedDoctorBookingSlot
                      caseId={customerId}
                      slotBooking={true}
                      formCategory={formData?.category}
                      orderDisplayId={orderDisplayId}
                      ticketObject={ticketObject}
                      setTicketObject={setTicketObject}
                    />
                  </div>
                )}
              {formData.mood && formData.callResponse === "answered" 
              // && (['yes', 'no'].includes(formData.is_doctor_required)) 
              && (
                <>
                  <Regularity
                    formData={formData}
                    buttonStyle={buttonStyle}
                    selected={selected}
                    setFormData={setFormData}
                    formRow={formRow}
                  />
                  {pushComponent("regularity", formData.regularity)}
                </>
              )}
              {formData?.regularity === "regular" &&
                formData?.callResponse === "answered" && (
                  <>
                    <Reaction
                      formData={formData}
                      buttonStyle={buttonStyle}
                      selected={selected}
                      formRow={formRow}
                      setFormData={setFormData}
                    />
                    {pushComponent("reaction", formData.reaction)}
                  </>
                )}
              {formData?.reaction === "yes" &&
                formData?.callResponse === "answered" && (
                  <>
                    <InputFeedback
                      setFormData={setFormData}
                      formData={formData}
                      orders={orders}
                      orderDisplayId={orderDisplayId}
                      setOrderDisplayId={setOrderDisplayId}
                      setTicketObject={setTicketObject}
                    />
                    {pushComponent("Sub-category", formData?.category)}
                    {pushComponent("Products Reactions", formData?.reactions)}
                  </>
                )}
              {formData?.reaction == "yes" &&
                formData?.callResponse === "answered" && (
                  <div>
                    <MedicalSlotBooking
                      caseId={customerId}
                      slotBooking={true}
                      formCategory={formData?.category}
                      orderDisplayId={orderDisplayId}
                      ticketObject={ticketObject}
                      setTicketObject={setTicketObject}
                    />
                  </div>
                )}
              {formData?.regularity === "irregular" &&
                formData?.callResponse === "answered" && (
                  <>
                    <Reasons
                      formData={formData}
                      setFormData={setFormData}
                      buttonStyle={buttonStyle}
                      selected={selected}
                      formRow={formRow}
                    />
                    {pushComponent("reason", formData?.reason)}
                  </>
                )}
              {formData?.reason &&
                formData?.regularity === "irregular" &&
                formData?.callResponse === "answered" && (
                  <>
                    <Reaction
                      formData={formData}
                      setFormData={setFormData}
                      buttonStyle={buttonStyle}
                      selected={selected}
                      formRow={formRow}
                    />
                    {pushComponent("reaction", formData?.reaction)}
                  </>
                )}
              {formData?.reaction && formData?.callResponse === "answered" && (
                <>
                  <Score
                    formData={formData}
                    buttonStyle={buttonStyle}
                    selected={selected}
                    setFormData={setFormData}
                    formRow={formRow}
                  />
                  {pushComponent("gutHealth", formData?.gutHealth)}
                  {pushComponent("energy", formData?.energy)}
                  {pushComponent("hairLoss", formData?.hairLoss)}
                  {pushComponent("hairGrowth", formData?.hairGrowth)}
                </>
              )}
              {formData?.gutHealth &&
                formData?.energy &&
                formData?.hairGrowth &&
                formData?.hairLoss &&
                (week === "Week #3" || week === "retention") &&
                formData?.callResponse === "answered" && (
                  <>
                    <ReasonForNotOrdering
                      formData={formData}
                      setFormData={setFormData}
                      buttonStyle={buttonStyle}
                      selected={selected}
                      formRow={formRow}
                    />
                    {pushComponent(
                      "reasonForNotOrdering",
                      formData?.reasonForNotOrdering
                    )}
                  </>
                )}
              {(((week !== "Week #3" || week !== "retention") &&
                formData?.gutHealth &&
                formData?.energy &&
                formData?.hairGrowth &&
                formData?.hairLoss) ||
                formData?.reasonForNotOrdering) &&
                formData?.callResponse === "answered" && (
                  <Comments
                    setFormData={setFormData}
                    length={formData?.comments?.length}
                  />
                )}
            </div>
          </div>
          {formData?.comments &&
            formData?.comments.length > 5 &&
            formData?.callResponse === "answered" && (
              <SaveFeedback
                orderCount={orderCount}
                setBooking={setBooking}
                setData={setData}
                customerId={customerId}
                setShow={setShow}
                bookingId={bookingId}
                week={week}
                formData={formData}
                selected={selected}
                buttonStyle={buttonStyle}
                formRow={formRow}
                renderedComponents={renderedComponents}
                id={id}
              />
            )}
            </div>
            </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default FeedbackForm;